export default __webpack_public_path__ + "static/media/chart_nodata.44a4d072.svg";